import * as React from 'react'
import AnnouncementBanner from '../../common/components/AnnouncementBanner/AnnouncementBanner';
import FeatureFlags from '../../types/featureflags';
import FeatureFlagService from '../../services/FeatureFlagService';

const CertificatesExpiryBanner = () => {
  const iconProps = {
    icon: {
      name: 'warning-filled',
      fill: '#d7af49',
      size: 22
    },
  };
  const shouldShowCertificatesExpiryBanner = FeatureFlagService.get(FeatureFlags.MONITORING_CENTER_MPKI_CERTS_EXPIRY_BANNER_ENABLED);

  if (!shouldShowCertificatesExpiryBanner) {
    return null;
  }

  return (
    <AnnouncementBanner {...iconProps} type="warning">
      <p> 
        The Anypoint Monitoring agent certificate expires on <b>September 25, 2025</b>.
        To understand potential impacts on <b>Runtime Fabric and on-premise runtime environments</b>, 
        refer to <a href="https://help.salesforce.com/s/articleView?id=005166859&type=1" target="_blank" rel="noopener noreferrer">
        this knowledge article</a>. Other runtime environments are not affected.
      </p>
    </AnnouncementBanner>  
  );
}

export default CertificatesExpiryBanner;
